// Hangul initial consonant mapping for search
const HANGUL_INITIALS = {
  'ㄱ': 0, 'ㄲ': 1, 'ㄴ': 2, 'ㄷ': 3, 'ㄸ': 4, 'ㄹ': 5, 'ㅁ': 6, 'ㅂ': 7, 'ㅃ': 8,
  'ㅅ': 9, 'ㅆ': 10, 'ㅇ': 11, 'ㅈ': 12, 'ㅉ': 13, 'ㅊ': 14, 'ㅋ': 15, 'ㅌ': 16, 'ㅍ': 17, 'ㅎ': 18
};

const INITIAL_CONSONANTS = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

export function getHangulInitial(char: string): string {
  const code = char.charCodeAt(0);
  if (code >= 0xAC00 && code <= 0xD7A3) {
    const initial = Math.floor((code - 0xAC00) / 588);
    return INITIAL_CONSONANTS[initial] || '';
  }
  return '';
}

export function matchesHangulSearch(text: string, searchTerm: string): boolean {
  if (!searchTerm) return true;
  
  const normalizedText = text.toLowerCase();
  const normalizedSearch = searchTerm.toLowerCase();
  
  // Direct match (full text or partial)
  if (normalizedText.includes(normalizedSearch)) {
    return true;
  }
  
  // Check if search term is all consonants (초성 검색)
  const isConsonantSearch = searchTerm.split('').every(char => 
    Object.keys(HANGUL_INITIALS).includes(char)
  );
  
  if (isConsonantSearch) {
    // Extract initials from text
    const textInitials = text.split('').map(getHangulInitial).join('');
    return textInitials.includes(searchTerm);
  }
  
  // Mixed search (some characters might be initials)
  let searchIndex = 0;
  for (let i = 0; i < text.length && searchIndex < searchTerm.length; i++) {
    const textChar = text[i];
    const searchChar = searchTerm[searchIndex];
    
    // Direct character match
    if (textChar.toLowerCase() === searchChar.toLowerCase()) {
      searchIndex++;
    }
    // Initial consonant match
    else if (getHangulInitial(textChar) === searchChar) {
      searchIndex++;
    }
  }
  
  return searchIndex === searchTerm.length;
} 